// extracted by mini-css-extract-plugin
export default {"paidFeatureGate":"YYNFYstiFtgw9jC9GTE1","paidPillWrapper":"tfu2o07a9gE3Wi2QKZqS"};